import { useMemo } from 'react';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

const routeLabels: Record<string, string> = {
  category: '漫画分类',
  article: '漫画阅读',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const paths = location.pathname.split('/').filter(Boolean);
    const items: BreadcrumbItem[] = [{ label: '首页', to: '/' }];

    if (paths.length === 0) return items;

    let currentPath = '';
    paths.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeLabels[segment] || decodeURIComponent(segment);
      items.push({
        label: label.length > 20 ? label.slice(0, 20) + '...' : label,
        to: currentPath,
      });
    });

    return items;
  }, [location.pathname]);

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.to && index < breadcrumbs.length - 1 ? (
              <Link
                to={item.to}
                className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}